import { Outlet } from 'react-router'
import Header from '../../../component/layout/header'
import useNav from '../../../component/custom-hooks/get-nav';

const SummaryDeviceLayout = () => {

  const navList = useNav();
  let {MainSummaryTopNav, DeviceSummaryBottomNav} = navList;

  return (
    <div className="webBody">
      <Header bottomTabs={DeviceSummaryBottomNav} topTabs={MainSummaryTopNav} />
      <Outlet />
    </div>
  )
}

export default SummaryDeviceLayout